<!--suppress JSUnusedLocalSymbols -->
<script>
    import 'datatables.net-bs/css/dataTables.bootstrap.min.css'
    import 'datatables.net-buttons-bs/css/buttons.bootstrap.min.css'
    import $ from 'jquery'
    import 'datatables.net'
    import 'datatables.net-bs'
    import 'datatables.net-buttons-bs'
    import 'datatables.net-buttons/js/buttons.colVis.js'
    import MspColumn from './MspColumn'

    const rowSelectorClass = 'row-selector';
    const rowSelectedEvent = 'row-selected';
    const actionIdAttribute = 'action-id';
    const asyncContentIdAttribute = 'async-content-id';
    const searchIconDefaultClass = 'glyphicon glyphicon-search';
    const refreshIconDefaultClass = 'glyphicon glyphicon-refresh';
    const tableFilterDivClass = 'tableFilter';
    const refreshTableDivClass = 'refreshTable';
    const tableActionsDivClass = 'actions';

    export default {
        name: "MspDataTable",
        props: {
            'dataSourceUrl': String,
            'keyField': String,
            'className': String,
            'serverSide': Boolean,
            'dataSourceMethod': String,
            'refreshButtonIcon': String,
            'searchButtonIcon': String,
            'selectableRows': Boolean,
            'selectedRowIcon': String,
            'unselectedRowIcon': String,
            'existsSelectedRowsIcon': String
        },
        render: function (createElement) {
            return createElement(
                'table',
                {
                    id: this.$attrs["id"],
                    style: {
                        width: "100%"
                    }
                },
                this.$slots.default
            )
        },
        components: {
            'msp-column': MspColumn
        },
        data: function () {
            return {
                columns: []
            }
        },
        computed: {
            getKeyField: function() {
                return this.keyField ? this.keyField : "id";
            }
        },
        methods: {
            refresh: function(){
                let tableDomElement = getTableDomElement(this);
                let dataTable = tableDomElement.DataTable();
                dataTable.draw();
            },
            addActionElement: function(actionDomElement){
                let tableDomElement = getTableDomElement(this);
                let actionDiv = tableDomElement.parent().find(`div.${tableActionsDivClass}`);
                actionDiv.append(actionDomElement);
            },
            getSelectedIds: function() {
                let tableDomElement = getTableDomElement(this);
                let dataTable = tableDomElement.DataTable();
                return getSelectedRowsIds(dataTable, this);
            }
        },
        mounted: function () {
            let dataTableConfig = prepareDataTableOptions(this.columns, this);
            let tableDomElement = getTableDomElement(this);
            tableDomElement.addClass(this.className);
            // noinspection SpellCheckingInspection
            let isServerSide = this.serverSide;
            let method = this.dataSourceMethod ? this.dataSourceMethod : "GET";
            let dataTable = tableDomElement.DataTable({
                "processing": isServerSide,
                "serverSide": isServerSide,
                "ajax": {
                    "url": this.dataSourceUrl,
                    "type": isServerSide ? "POST" : method,
                    "dataType": "json"
                },
                order: this.selectableRows ? [[1, 'asc']] : [[0, 'asc']],
                "columns": dataTableConfig.dtColumns,
                "columnDefs": dataTableConfig.dtColumnDefs,
                "buttons": ['colvis'],
                "dom":
                    `<"row no-gutters"
                        <"col-sm-12 col-md-6 text-left"<"${tableFilterDivClass}">>
                        <"col-sm-12 col-md-6 text-right"<"inlineBlock"l><"inlineBlock"B>>
                    >
                    <"${tableActionsDivClass}">
                    rt
                    <"row no-gutters"<"col-sm-12 col-md-6"<"${refreshTableDivClass}"><"inlineBlock"i>><"col-sm-12 col-md-6"p>>`
            });

            let columnComponents = this.columns;
            createTableFilter(this, columnComponents, tableDomElement, dataTable);
            createTableRefreshButton(dataTable, this, tableDomElement);

            let tableComponent = this;
            initRowSelecting(tableDomElement, dataTable, tableComponent);
            adjustTableToolbarElements(tableDomElement);

            tableDomElement.on('click', `[${actionIdAttribute}]`, function () {
                let actionElement = $(this);
                processClickEventOnActionElement(actionElement, dataTable, columnComponents, tableComponent);
            });

            dataTable.on('draw', function () {
                updateSelectIconInHeader(tableDomElement, dataTable, tableComponent);
                createAsyncElements(tableDomElement, dataTable, columnComponents, tableComponent);
            });
        }
    };

    function adjustTableToolbarElements(tableDomElement) {
        tableDomElement.parent().find('div.inlineBlock')
            .css("display", "inline-block")
            .css("padding-left", "10px");
        tableDomElement.parent().find(`div.${tableActionsDivClass}`)
            .css("display", "inline-block")
            .css("padding", "5px 0 3px 0");
        tableDomElement.parent().find(`div.${refreshTableDivClass}`)
            .css("display", "inline-block")
            .css("padding-left", "0");
    }

    function addRowsSelectionColumn(tableComponent, columnNumber, dataTableConfig) {
        if (tableComponent.selectableRows) {
            let dtColumnDef = {
                "targets": columnNumber,
                "width": "30px",
                "title": `<span class="${rowSelectorClass}">${tableComponent.unselectedRowIcon}</i></span>`,
                "className": "text-center",
                "orderable": false,
                // eslint-disable-next-line no-unused-vars
                "render": function (data, type, model) {
                    return `<span class="${rowSelectorClass}">${tableComponent.unselectedRowIcon}</i></span>`;
                }
            };
            dataTableConfig.dtColumns.push({data: null});
            dataTableConfig.dtColumnDefs.push(dtColumnDef);
            columnNumber++;
        }
        return columnNumber;
    }

    function setRowCheckedIcon(row, tableComponent) {
        let td = row.children('td').first();
        if (row.hasClass('selected')) {
            td.html(`<span class="${rowSelectorClass}">${tableComponent.selectedRowIcon}</i></span>`);
        } else {
            td.html(`<span class="${rowSelectorClass}">${tableComponent.unselectedRowIcon}</i></span>`);
        }
    }

    function updateSelectIconInHeader(tableDomElement, dataTable, tableComponent) {
        let selectedRowsLength = dataTable.rows('.selected').nodes().length;
        let hr = tableDomElement.find('thead>tr').first();
        let th = hr.find('th').first();
        if (selectedRowsLength === dataTable.rows().nodes().length) {
            th.html(`<span class="${rowSelectorClass}">${tableComponent.selectedRowIcon}</i></span>`);
        } else if (selectedRowsLength > 0) {
            th.html(`<span class="${rowSelectorClass}">${tableComponent.existsSelectedRowsIcon}</i></span>`);
            hr.addClass('selected');
        } else {
            th.html(`<span class="${rowSelectorClass}">${tableComponent.unselectedRowIcon}</i></span>`);
        }
    }

    function emitAboutSelectedRows(dataTable, tableComponent, tableDomElement) {
        let ids = getSelectedRowsIds(dataTable, tableComponent);
        tableComponent.$emit(rowSelectedEvent, ids);
        updateSelectIconInHeader(tableDomElement, dataTable, tableComponent);
    }

    function getSelectedRowsIds(dataTable, tableComponent){
        return dataTable.rows('.selected').data().map(d => d[tableComponent.getKeyField]);
    }

    function initRowSelecting(tableDomElement, dataTable, tableComponent) {
        tableDomElement.find('tbody').on('click', `tr>td>.${rowSelectorClass}`, function () {
            let tr = $(this).parent().parent();
            tr.toggleClass('selected');
            // noinspection JSUnresolvedFunction
            setRowCheckedIcon(tr, tableComponent);
            emitAboutSelectedRows(dataTable, tableComponent, tableDomElement);
        });
        tableDomElement.find('thead').on('click', `tr>th>.${rowSelectorClass}`, function () {
            let row = $(this).parent().parent();
            row.toggleClass('selected');
            // noinspection JSUnresolvedFunction
            let th = row.children('th').first();
            if (row.hasClass('selected')) {
                th.html(`<span class="${rowSelectorClass}">${tableComponent.selectedRowIcon}</i></span>`);
                dataTable.rows().nodes().to$().addClass('selected');
            }
            else {
                th.html(`<span class="${rowSelectorClass}">${tableComponent.unselectedRowIcon}</i></span>`);
                dataTable.rows('.selected').nodes().to$().removeClass('selected');
            }
            dataTable.rows().nodes().each(row => setRowCheckedIcon($(row), tableComponent));
            emitAboutSelectedRows(dataTable, tableComponent, tableDomElement);
        });
    }

    function getTableDomElement(tableComponent) {
        let id = tableComponent.$attrs["id"];
        return id ? $('table#' + id).first() : $('table').first();
    }

    function createAsyncElements(tableDomElement, dataTable, columnComponents, tableComponent) {
        let asyncElementsData = getAsyncElementsOptions(tableDomElement, dataTable, columnComponents, tableComponent);
        if (0 === asyncElementsData.length) {
            return;
        }

        asyncElementsData.sort((a, b) => {
            if (a.columnNo > b.columnNo || (a.columnNo === b.columnNo && a.controlNo > b.controlNo)) {
                return 1;
            }
            if (a.columnNo === b.columnNo && a.controlNo === b.controlNo) {
                return 0;
            }
            if (a.columnNo < b.columnNo || (a.columnNo === b.columnNo && a.controlNo < b.controlNo)) {
                return -1;
            }
        });
        let currentColumn = asyncElementsData[0].columnNo;
        let currentControl = asyncElementsData[0].controlNo;
        let promisesArray = [];
        for (let i = 0; i < asyncElementsData.length; i++) {
            let nextElementData = asyncElementsData[i];
            let asyncContent = nextElementData.asyncComponent.getAsyncContent(nextElementData.modelId, nextElementData);
            if (currentColumn === nextElementData.columnNo && currentControl === nextElementData.controlNo) {
                promisesArray.push(asyncContent)
            } else {
                fillAsyncElementsContent(promisesArray);
                currentColumn = nextElementData.columnNo;
                currentControl = nextElementData.controlNo;
                promisesArray = [asyncContent];
            }
        }
        fillAsyncElementsContent(promisesArray);
    }

    function transformColumnTemplateToValidJavaScript (templateComponent) {
        if (!templateComponent.$slots.default) {
            return "";
        }
        let templateElements = templateComponent.$slots.default.map(function (vNode) {
            // noinspection JSUnresolvedVariable
            return vNode.text ? vNode.text : vNode.elm.outerHTML;
        });
        let templateText = "<div>" + templateElements.join('').trim() + "</div>";
        return "'" + templateText
                .replace(/\r?\n|\r/g, "")
                .replace(/"/g, "\\'")
                .replace(/\[\[\s*if\([^[]*\)\s*\?\s*]]/g,
                    str => "'+(" + (
                        str.replace("[[", "")
                            .replace("]]", "")
                            .replace("if", "")) + "('")
                .replace(/\[\[\s*:\s*]]/g,
                    str => "')" + (
                        str.replace("[[", "")
                            .replace("]]", "")) + "'')+'")
                .replace(/\[\[/g, "'+")
                .replace(/]]/g, "+'")
                .replace(/^\+'/g, "")
                .replace(/'\+$/g, "")
        +"'";
    }

    function setRenderFunctionForDataTableColumn(columnComponent, dtColumnDef, actionTemplatesString, asyncContentTemplatesString) {
        if (columnComponent.template) {
            let templateResult = transformColumnTemplateToValidJavaScript(columnComponent.template);
            // eslint-disable-next-line no-unused-vars
            dtColumnDef.render = function (data, type, model, meta) {
                let templateAfterEval;
                try {
                    // noinspection DynamicallyGeneratedCodeJS
                    templateAfterEval = eval(templateResult);
                } catch (err) {
                    templateAfterEval = `Error in template: ${err.message}`;
                }
                return templateAfterEval + actionTemplatesString;
            };
        } else if (columnComponent.$props.modelProperty && (actionTemplatesString || asyncContentTemplatesString)) {
            // eslint-disable-next-line no-unused-vars
            dtColumnDef.render = function (data, type, model) {
                return data + asyncContentTemplatesString + actionTemplatesString;
            }
        } else if (actionTemplatesString || asyncContentTemplatesString) {
            // eslint-disable-next-line no-unused-vars
            dtColumnDef.render = function (data, type, model) {
                return asyncContentTemplatesString + actionTemplatesString;
            }
        }
    }

    function prepareDataTableOptions (columnComponents, tableComponent) {
        let dataTableConfig = {
            dtColumns: [],
            dtColumnDefs: []
        };
        let columnNumber = 0;
        columnNumber = addRowsSelectionColumn(tableComponent, columnNumber, dataTableConfig);
        columnComponents.forEach(function (columnComponent) {
            let dtColumnDef = {
                "targets": columnNumber,
                "title": columnComponent.header,
                "orderable": columnComponent.sortable
            };
            if (columnComponent.className) {
                dtColumnDef.className = columnComponent.className;
            }
            let modelProperty = columnComponent.$props.modelProperty;
            dataTableConfig.dtColumns.push({data: modelProperty ? modelProperty : null});

            let asyncContentTemplates = "";
            let asyncContentNumber = 0;
            let activeColumnNumber = tableComponent.selectableRows ? columnNumber - 1 : columnNumber;
            columnComponent.asyncContents.forEach(function (asyncContent) {
                // noinspection HtmlUnknownAttribute
                asyncContentTemplates += `<span ${asyncContentIdAttribute}='${activeColumnNumber}_${asyncContentNumber}'>${asyncContent.spinTemplate}</span>`;
                asyncContentNumber++;
            });

            let actionTemplates = "";
            let actionNumber = 0;
            columnComponent.actions.forEach(function (action) {
                if (action.template) {
                    let html = $.parseHTML(`<span>${action.template}&nbsp;</span>`);
                    let htmlObject = $(html);
                    htmlObject.first().attr(`${actionIdAttribute}`, activeColumnNumber + "_" + actionNumber);
                    htmlObject.css('cursor', 'pointer');
                    actionTemplates += htmlObject.prop('outerHTML');
                    actionNumber++
                }
            });
            setRenderFunctionForDataTableColumn(columnComponent, dtColumnDef, actionTemplates, asyncContentTemplates);

            dataTableConfig.dtColumnDefs.push(dtColumnDef);
            columnNumber++;
        }, this);

        return dataTableConfig;
    }

    function createTableFilter (tableComponent, columnComponents, tableElement, dataTable) {
        let columnsHtmlList = '';
        columnComponents.forEach(function (column) {
            // noinspection HtmlUnknownAttribute
            columnsHtmlList += `<li><a href="#" value="${column.header}">${column.header}</a></li>`;
        });
        tableElement.parent().find('div.tableFilter').each(function () {
            let tableFilter = $(this);
            tableFilter.html(`
                    <div class="input-group">
                      <div class="input-group-btn">
                        <button type="button" class="btn btn-default main">Select column...</button>
                        <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="caret"></span>
                            <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <ul class="dropdown-menu">
                        ${columnsHtmlList}
                        </ul>
                      </div>
                      <input type="text" class="form-control" aria-label="...">
                      <span class="input-group-btn">
                        <button type="button" class="btn btn-default search">
                            ${ tableComponent.searchButtonIcon ? tableComponent.searchButtonIcon : `<span class='${searchIconDefaultClass}' aria-hidden='true'></span>`}
                        </button>
                      </span>
                    </div>
                    `);
            let filterButton = tableFilter.find('button.main');
            let filterElement = tableFilter.find('a');
            let filterInput = tableFilter.find('input');
            let filterSearchButton = tableFilter.find('button.search');
            filterElement.on('click', function () {
                let value = $(this).attr('value');
                filterButton.html(value);
                filterSearchButton.off('click');

                dataTable.columns().every(function () {
                    let column = this;
                    column.search('');
                    let header = column.header();
                    // eslint-disable-next-line no-undef
                    let title = $(header).html();
                    if (title === filterButton.html()) {
                        filterSearchButton.on('click', function () {
                            let val = filterInput.val();
                            column.search(val).draw();
                        });
                    }
                });
            });
        });
    }

    function createTableRefreshButton(dataTable, tableComponent, tableDomElement){
        tableDomElement.parent().find('div.refreshTable').each(function () {
            let refreshTable = $(this);
            refreshTable.html(`
                    <div class="input-group">
                        <button type="button" class="btn btn-default">
                            ${ tableComponent.refreshButtonIcon ? tableComponent.refreshButtonIcon : `<span class='${refreshIconDefaultClass}' aria-hidden='true'></span>`}
                        </button>
                    </div>
                    `);
            let refreshTableButton = refreshTable.find('button');
            refreshTableButton.on('click', function () {
                dataTable.rows('.selected').nodes().to$().removeClass('selected');
                $(dataTable.table().header()).find("tr").removeClass('selected');
                dataTable.rows().nodes().each(row => setRowCheckedIcon($(row), tableComponent));
                emitAboutSelectedRows(dataTable, tableComponent, tableDomElement);
                tableComponent.refresh();
            });
        });
    }

    function processClickEventOnActionElement (actionElement, dataTable, columnComponents, tableComponent) {
        let tr = actionElement.parents("tr");
        let model = dataTable.row(tr).data();
        let actionId = actionElement.attr(`${actionIdAttribute}`);
        if (actionId) {
            let actionIdArray = actionId.split('_');
            let action = columnComponents[+actionIdArray[0]].actions[+actionIdArray[1]];
            if (action.confirmMessage) {
                if (confirm(action.confirmMessage)) {
                    action.onAction(model[tableComponent.getKeyField]);
                }
            } else {
                action.onAction(model[tableComponent.getKeyField]);
            }
        }
    }

    function getAsyncElementsOptions (tableDomElement, dataTable, columnComponents, tableComponent) {
        let asyncElements = [];
        tableDomElement.find(`[${asyncContentIdAttribute}]`).each(function () {
            let contentElement = $(this);
            let tr = contentElement.parents("tr");
            let model = dataTable.row(tr).data();
            let contentId = contentElement.attr(`${asyncContentIdAttribute}`);
            if (contentId) {
                let contentIdArray = contentId.split('_');
                let asyncComponent = columnComponents[+contentIdArray[0]].asyncContents[+contentIdArray[1]];
                asyncElements.push({
                    contentId: contentId,
                    modelId: model[tableComponent.getKeyField],
                    contentElement: contentElement,
                    asyncComponent: asyncComponent,
                    columnNo: +contentIdArray[0],
                    controlNo: +contentIdArray[1]
                });
            }
        });
        return asyncElements;
    }

    function isContentEmpty (content) {
        const trimmedContent = content.replace(/&nbsp;|\s/g, "").trim();
        return !trimmedContent;
    }

    function fillAsyncElementsContent (promisesArray) {
        Promise.all(promisesArray).then(values => {
            let allContentIsEmpty = true;
            values.forEach(value => {
                if (value.element)
                    {
                        allContentIsEmpty &= isContentEmpty(value.content);
                    }
            });
            values.forEach(value => {
                if (value.element)
                    {
                        if (allContentIsEmpty) {
                            value.element.contentElement.html('');
                        } else {
                            value.element.contentElement.html(value.content);
                        }
                    }
            })
        }, reason => {
            if (reason.element) {
                reason.element.contentElement.html(reason.content);
            }
        });
    }
</script>
<style>
    /*noinspection CssUnusedSymbol*/
    .row.no-gutters {
        margin-right: 0;
        margin-left: 0;
    }
    .row.no-gutters > [class*="col-"] {
        padding-right: 0;
        padding-left: 0;
    }

    /*noinspection ALL*/
    tbody>tr.selected, .table-striped>tbody>tr:nth-of-type(odd).selected{
        background-color: #aab7d1;
    }
</style>